import React, { useState, useEffect } from "react";
import "./Rules.css";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";

export default function RulesCard({ index, item, reload, userType }) {
  const [loading, setLoading] = useState(false);
  const [backend, setBackend] = useState(null);
  const [tpassword, setTpassword] = useState("");

  const [openClearModal, setOpenClearModal] = useState(false);

  useEffect(() => {
    (async () => {
      const b = await new Backend().init();
      setBackend(b);
    })();
  }, []);

  const handleDelete = async () => {
    if (!backend) return;

    if (!tpassword) {
      toast.error("Please enter transaction password");
      return;
    }

    setLoading(true);
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        tpassword: tpassword,
        rules_id: item.id,
      };

      const response = await backend.delete_rules(data);
      setLoading(false);

      if (response.error === "False") {
        toast.success(response.message);
        reload();
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      toast.error("Failed to delete rule.");
    }
  };

  return (
    <>
      <div className="RulesContainer">
        <div className="RulesExchange">
          {index.index + 1}. {item.msg}
        </div>

        {userType === 1 && (
          <button
            onClick={() => (!loading ? setOpenClearModal(true) : undefined)}
            disabled={loading}
            className="px-4 py-1.5 bg-[var(--sell)] text-white rounded-full text-sm font-semibold shadow"
          >
            {loading ? "DELETING..." : "DELETE"}
          </button>
        )}
      </div>

      {/* 🔥 CLEAR MODAL */}
      {openClearModal && (
        <div
          className="customModalOverlay"
          onClick={() => setOpenClearModal(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Delete Rules</h3>
            <p className="customModalWarning">
              This action will delete rules data for server.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setOpenClearModal(false)}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                className="dropbtnNavSub white primary"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? "Clearing..." : "Confirm Clear"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
